// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text-btn":"tooltip__text-btn___9hbMj","textBtn":"tooltip__text-btn___9hbMj"};
    if(module.hot) {
      // 1771039681345
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  